import { useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { FixedActionBar, RecordActionSlot } from '../record-layout.tsx';

/**
 * Handy-Knopfleiste der Grundstein-Köpfe (Ticket 1.241): steht samt Platzhalter am Ende der Seite, nie direkt unter dem
 * Kopf (sonst bleibt dort eine leere Lücke und der letzte Inhalt liegt unter der Leiste). In `RecordLayout` im
 * vorgesehenen Platz (`RecordActionSlot`), sonst am Ende des Dokuments.
 */
export function PhoneActionBar({ children, framed = false }: { children: ReactNode; /** Opt-in (Ticket 1.273), siehe `FixedActionBar`. */ framed?: boolean }) {
  const slot = useContext(RecordActionSlot);
  const target = slot ?? (typeof document === 'undefined' ? null : document.body);
  const bar = <FixedActionBar framed={framed}>{children}</FixedActionBar>;
  return target ? createPortal(bar, target) : bar;
}
